




















































































import Vue from 'vue'
import { Component } from 'vue-property-decorator';

import { RobotOption, TwitterCardOption } from '@/models/MetaTags';
import { getLocalesString } from '@/models/Locale';
import { BusyObject } from '@/models/Busy';
import { Subscription } from '@/api/braendz';
import { AccountInfo } from '@azure/msal-browser';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import ProductCardStarter from '@/components/Products/ProductCardStarter.vue';
import ProductCardProfessional from '@/components/Products/ProductCardProfessional.vue';
import ProductCardEnterprise from '@/components/Products/ProductCardEnterprise.vue';

@Component({
  components: {
    LoadingView,
    ProductCardStarter,
    ProductCardProfessional,
    ProductCardEnterprise
  },
  metaInfo() {
    return {
      title: this.$i18n.t("products.title").toString(),
      meta: [
        // Search Engines:
        { name: 'title', content: this.$i18n.t("products.metaTags.title").toString() },
        { name: 'description', content: this.$i18n.t("products.metaTags.description").toString() },
        { name: 'author', content: this.$i18n.t("metaTags.author").toString() },
        { name: 'language', content: this.$i18n.locale },
        { name: 'robots', content: [RobotOption.All].join(',') },

        // Open Graph: Facebook, Instagram, WhatsApp, LinkedIn, Xing, Twitter:
        { property: 'og:type', content: "website" },
        { property: 'og:title', content: this.$i18n.t("products.metaTags.title").toString() },
        { property: 'og:description', content: this.$i18n.t("products.metaTags.description").toString() },
        { property: 'og:image', content: `${window.location.origin}${require('@/assets/logos/braendz-logo-tm-blue.png')}` },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:locale:alternate', content: getLocalesString(',') },
        { property: 'og:site_name', content: this.$i18n.t("metaTags.title").toString()},

        // Twitter:
        { property: 'twitter:card', content: TwitterCardOption.SummaryLargeImage },
        { property: 'twitter:site', content: `@${process.env.VUE_APP_TWITTER_ACCOUNT}` }
      ]
    };
  }
})
export default class Products extends Vue {
    // Member:

    // Getter:
    public get isInitializing(): boolean {
        return this.$store.state.activeSubscription.isBusy 
            || this.$store.state.account.isBusy;
    }

    public get userAccount(): AccountInfo | null {
        return this.$store.state.userAccount;
    }

    public get activeSubscription(): BusyObject<Subscription> {
        return this.$store.state.activeSubscription;
    }

    public get activeProductKey(): string | null {
        return this.activeSubscription.object?.product?.key || null;
    }

    // Lifecycle Methods:

    // Methods
}
